import React, { useMemo } from 'react';
import { getSeasonalEffectType } from '../../utils/seasonalEffect';
import SakuraPetals from './SakuraPetals';
import SummerWaves from './SummerWaves';
import AutumnLeaves from './AutumnLeaves';
import WinterSnow from './WinterSnow';

const EFFECT_COMPONENTS = {
  sakura: SakuraPetals,
  waves: SummerWaves,
  autumn: AutumnLeaves,
  snow: WinterSnow,
};

function SeasonalEffect() {
  const effectType = useMemo(() => getSeasonalEffectType(), []);
  const EffectComponent = EFFECT_COMPONENTS[effectType];

  return <EffectComponent />;
}

export default SeasonalEffect;
